<p>auth-flow-selector works!</p>
